<div class="price-preferences-container">
  <form [formGroup]="formGroup">
    <div class="header">
      <div class="header-title">
        <pdq-heading element="h5">Price settings</pdq-heading>
        @if (!settings?.scriptTagEnabled) {
        <pdq-icon size="smaller" icon="Attention" color="var(--warning-default)"></pdq-icon>
        }
      </div>
    </div>

    <div>
      <div class="content">
        Choose how shipping rules calculate cart value
        <pdq-radio-group [formControl]="formGroup.controls['subTotalIncludesDiscounts']">
          <pdq-radio-button
            [value]="false"
            [checked]="formGroup.value['subTotalIncludesDiscounts'] == false"
            text="Cart subtotal (excludes coupons)"></pdq-radio-button>
          <pdq-radio-button
            [value]="true"
            [checked]="formGroup.value['subTotalIncludesDiscounts'] == true"
            text="Cart total (includes coupons)"></pdq-radio-button>
        </pdq-radio-group>
      </div>
      <div class="content">
        Multi-origin carts
        <pdq-checkbox
          label="Prevent duplicate shipping charges for multi-origin orders"
          labelSize="small"
          formControlName="preventMultipleShippingCost"></pdq-checkbox>
      </div>
    </div>
  </form>
</div>
